import { stopSubmit } from "redux-form";
import { all, call, put, takeLatest } from "redux-saga/effects";
import { loginFormId } from "../../components/dialog/LoginDialog/LoginDialog";
import { loginService } from "../../services/login.service";
import { appActions } from "../../store/app.store";
import { systemActions } from "../../store/system.store";
import { uiActions } from "../../store/ui.store";
import { constants } from "../../util/constants";
import { loginPageActions } from "./login-page.store";

/**
 * ユーザーがログインボタンをクリックした
 * @param action
 */
function* onUserClickedLoginButton(
  action: ReturnType<typeof loginPageActions.USER_CLICKED_LOGIN_BUTTON>
) {
  try {
    yield put(uiActions.REDUCER_LOADING_STARTED());

    const res = yield call(
      loginService.login,
      action.payload.username,
      action.payload.password
    );

    if (res) {
      localStorage.setItem(constants.STORAGE_KEY_USER, JSON.stringify(res));
      yield put(appActions.REDUCER_SET_LOGIN_USER(res));
      yield put(systemActions.SYSTEM_INITIALIZE_APPLICATION());
    } else {
      yield put(stopSubmit(loginFormId, { _error: "ログインに失敗しました" }));
    }
  } finally {
    yield put(uiActions.REDUCER_LOADING_STOPPED());
  }
}

/**
 * ログイン画面サーガ
 */
export function* loginPageSagas() {
  yield all([
    yield takeLatest(
      loginPageActions.USER_CLICKED_LOGIN_BUTTON,
      onUserClickedLoginButton
    )
  ]);
}
